import React, { useEffect } from 'react';
import { BiCheckCircle } from "react-icons/bi";
import Cart from '../components/checkout/Cart';

const OrderSummary = () => {
    const successData = JSON.parse(sessionStorage.getItem('success'))

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    return (
        <div className='bg-gray-200'>
            <div className='container mx-auto  sm:p-0 md:p-5'>
                <div className='bg-white grid grid-cols-5 pt-5 p-4'>
                    <div className='md:col-span-2 col-span-5'>
                        <div className='bg-gray-50 mt-3 p-3'>
                            <div className="mark-icon text-center">
                                <div className='w-full flex justify-center'>
                                    <BiCheckCircle className='text-4xl font-bold text-green-600' />
                                </div>
                                <h3 className='text-2xl font-normal text-gray-600 mb-3'>Thank you for your online purchase</h3>
                                <p className='t text-gray-600'>This is a confirmation and summary of your order which is currently being processed.</p>
                            </div>
                            <div className='p-4'>
                                {
                                    [successData].map((item) => (
                                        <ul className="list-disc">
                                            <li className='text-gray-600 font-poppins text-sm pb-1'>Order Id : <span className='font-semibold'>{item?._id}</span></li>
                                            <li className='text-gray-600 font-poppins text-sm pb-1'>Date : <span className='font-semibold'>{item?.PlacedDate}</span></li>
                                            <li className='text-gray-600 font-poppins text-sm pb-1'>Email : <span className='font-semibold'>{item?.contactInfo.email}</span></li>
                                            <li className='text-gray-600 font-poppins text-sm pb-1'>Total : <span className='font-semibold'>{item?.totalPrice} BDT</span></li>
                                            <li className='text-gray-600 font-poppins text-sm pb-1'>payment status : <span className='font-semibold'>{item?.paidStatus}</span></li>
                                        </ul>
                                    ))
                                }
                            </div>
                        </div>
                    </div>
                    <div className='grid md:col-span-3 col-span-5  mt-3 p-3'>
                        <h3 className='text-2xl font-poppins text-gray-500 pb-3 mb-2 border-b'>Order Details</h3>
                        <Cart orderSmr={true} />
                        <div>
                            <div className='py-2 mt-1 px-3'>
                                <h3 className='text-2xl text-gray-600 font-poppins'>Bill Address</h3>
                                <p className='text-gray-600 italic text-sm mb-1 font-normal font-poppins'>{successData?.deliveryAddress?.address}</p>
                                <p className='text-gray-600 italic text-sm mb-1 font-normal font-poppins'>{successData?.deliveryAddress?.addressFillds[0].split(' ')[1]}</p>
                                <p className='text-gray-600 italic text-sm mb-1 font-normal font-poppins'>{successData?.deliveryAddress?.addressFillds[1].split(' ')[1]}</p>
                                <p className='text-gray-600 italic text-sm mb-1 font-normal font-poppins'>{successData?.deliveryAddress?.addressFillds[2].split(' ')[1]}</p>
                                <p className='text-gray-600 italic text-sm mb-1 font-normal font-poppins'>{successData?.deliveryAddress?.addressFillds[3].split(' ')[1]}</p>
                                <p className='text-gray-600 italic text-sm mb-1 font-normal font-poppins'>{successData?.contactInfo?.phone}</p>
                                <p className='text-gray-600 italic text-sm mb-1 font-normal font-poppins'>{successData?.contactInfo?.email}</p>
                            </div>
                            <div className='py-2 px-3'>
                                <h3 className='text-2xl text-gray-600 font-poppins'>Shipping Address</h3>
                                <p className='text-gray-600 italic text-sm mb-1 font-normal font-poppins'>{successData?.deliveryAddress?.address}</p>
                                <p className='text-gray-600 italic text-sm mb-1 font-normal font-poppins'>{successData?.deliveryAddress?.addressFillds[0].split(' ')[1]}</p>
                                <p className='text-gray-600 italic text-sm mb-1 font-normal font-poppins'>{successData?.deliveryAddress?.addressFillds[1].split(' ')[1]}</p>
                                <p className='text-gray-600 italic text-sm mb-1 font-normal font-poppins'>{successData?.deliveryAddress?.addressFillds[2].split(' ')[1]}</p>
                                <p className='text-gray-600 italic text-sm mb-1 font-normal font-poppins'>{successData?.deliveryAddress?.addressFillds[3].split(' ')[1]}</p>
                                <p className='text-gray-600 italic text-sm mb-1 font-normal font-poppins'>{successData?.contactInfo?.phone}</p>
                                <p className='text-gray-600 italic text-sm mb-1 font-normal font-poppins'>{successData?.contactInfo?.email}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default OrderSummary;